import React from "react";
import { Banknote, CreditCard, Smartphone, Wallet } from "lucide-react";

export function normalizePaymentMethod(
  method: string | null | undefined,
): string {
  if (!method) return "Dinheiro";
  const upper = method.toUpperCase().trim();
  if (upper === "PIX") return "PIX";
  if (
    upper === "CREDITO" ||
    upper === "CARTAO_CREDITO" ||
    upper === "CARTÃO DE CRÉDITO" ||
    upper === "CARTAO DE CREDITO" ||
    upper === "CREDIT_CARD"
  ) {
    return "Cartão de Crédito";
  }
  if (
    upper === "DEBITO" ||
    upper === "CARTAO_DEBITO" ||
    upper === "CARTÃO DE DÉBITO" ||
    upper === "CARTAO DE DEBITO" ||
    upper === "DEBIT_CARD"
  ) {
    return "Cartão de Débito";
  }
  if (upper === "DINHEIRO" || upper === "CASH" || upper === "ESPECIE") {
    return "Dinheiro";
  }
  return method;
}

export function getPaymentMethodIcon(methodName: string) {
  const norm = methodName.toLowerCase();
  if (norm.includes("pix")) {
    return React.createElement(Smartphone, {
      size: 18,
      className: "text-emerald-400",
    });
  }
  if (norm.includes("crédito") || norm.includes("credito")) {
    return React.createElement(CreditCard, {
      size: 18,
      className: "text-blue-400",
    });
  }
  if (norm.includes("débito") || norm.includes("debito")) {
    return React.createElement(CreditCard, {
      size: 18,
      className: "text-purple-400",
    });
  }
  if (norm.includes("dinheiro")) {
    return React.createElement(Banknote, {
      size: 18,
      className: "text-amber-400",
    });
  }
  return React.createElement(Wallet, {
    size: 18,
    className: "text-indigo-400",
  });
}

export function getPaymentMethodColor(methodName: string) {
  const norm = methodName.toLowerCase();
  if (norm.includes("pix"))
    return {
      bg: "bg-emerald-500",
      text: "text-emerald-400",
      badge: "bg-emerald-500/10 border-emerald-500/20",
    };
  if (norm.includes("crédito") || norm.includes("credito"))
    return {
      bg: "bg-blue-500",
      text: "text-blue-400",
      badge: "bg-blue-500/10 border-blue-500/20",
    };
  if (norm.includes("débito") || norm.includes("debito"))
    return {
      bg: "bg-purple-500",
      text: "text-purple-400",
      badge: "bg-purple-500/10 border-purple-500/20",
    };
  if (norm.includes("dinheiro"))
    return {
      bg: "bg-amber-500",
      text: "text-amber-400",
      badge: "bg-amber-500/10 border-amber-500/20",
    };
  return {
    bg: "bg-indigo-500",
    text: "text-indigo-400",
    badge: "bg-indigo-500/10 border-indigo-500/20",
  };
}
